import { render, staticRenderFns } from "./BaseWordsList.vue?vue&type=template&id=8d215a52&scoped=true&"
import script from "./BaseWordsList.vue?vue&type=script&lang=js&"
export * from "./BaseWordsList.vue?vue&type=script&lang=js&"
import style0 from "./BaseWordsList.vue?vue&type=style&index=0&id=8d215a52&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d215a52",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!C:/dev/www/word-trainer-admin/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib'
import { VCardTitle } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VImg } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {VCard,VCardTitle,VContainer,VFlex,VImg,VLayout})
